// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1655":"afed494b","2823":"743c55ae","6346":"afed494b","7144":"afed494b","9886":"f16c9b18","9988":"41870722"}[chunkId] + ".chunk.css";
};